import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MicroIcon = React.memo(
  ({ fill = variables['colors-mc-gray'], width = 24, viewBox = '0 0 24 24', opacity = '0.5' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect id='Rectangle_1407' data-name='Rectangle 1407' width='24' height='24' fill='none' />
      <path
        id='Path_12335'
        data-name='Path 12335'
        d='M13,17.93q0,.035,0,.07v3a1,1,0,1,1-2,0V18q0-.036,0-.07A7,7,0,0,1,5,11H7a5,5,0,0,0,10,0h2A7,7,0,0,1,13,17.93Z'
        fill={fill}
        opacity={opacity}
      />
      <rect
        id='Rectangle_1408'
        data-name='Rectangle 1408'
        width='6'
        height='12'
        rx='3'
        transform='translate(9 2)'
        fill={fill}
        opacity={opacity}
      />
    </svg>
  )
);
MicroIcon.displayName = 'MicroIcon';

export default MicroIcon;
